import CreditCardIcon from "../assets/creditCardIcon"
import PeopleIcon from "../assets/peopleIcon"
import RocketIcon from "../assets/rocketIcon"
import ThursdayGreyScale from "../assets/thursdayGreyLogo"
import WineGlassIcon from "../assets/wineGlassIcon"
import React from "react"

export const faqQuestionAnswers = [
  [
    <>
      <div className="accordion-icon">
        <CreditCardIcon size="19" />
      </div>
      Is Thursday free to use?
    </>,
    `Thursday is made by True Sparrow, a product studio and is completely free to use. In fact, you can host socials without even signing up.`,
  ],
  [
    <>
      <div className="accordion-icon">
        <PeopleIcon color="black" size="19" />
      </div>{" "}
      How many max participants can be in a social?
    </>,
    "You can host a social and invite up to 200 participants. So go ahead and invite your team.",
  ],
  // [
  //   <>
  //     <div className="accordion-icon">
  //       <ThursdayGreyScale color="black" size="18" />
  //     </div>
  //     Would I be billed for all the members of my team?
  //   </>,
  //   "In our Team plan, we only bill you for active users. Active users are the ones who participate in at least one of our activities in a given billing cycle.",
  // ],
  [
    <>
      <div className="accordion-icon">
        <WineGlassIcon color="black" size="19" />
      </div>
      What are mixers?
    </>,
    "Mixers are fun and engaging social activities played in small groups. Currently on air: Drunk Startups, Doodle Race, Trivia, Would You Rather, 2 truths & a lie, Charades, Speed 1-on-1, Mindful Talks, and Know Your Team.",
  ],
  [
    <>
      <div className="accordion-icon">
        <RocketIcon size="20" />
      </div>
      Does a host need to drive the social?
    </>,
    "Yes, there has to be a host who can drive the social. The host can add/remove mixers depending on what the team is enjoying and how long they want the social to go on.",
  ],
]
